module.exports = __webpack_public_path__ + "static/media/link.19a3e895.svg";